import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import AuthService from "../services/auth.service";

import { withRouter } from '../common/with-router';
import {Link} from "react-router-dom";

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      username: "",
      password: "",
      loading: false,
      message: "",
      loaded: false,
    };
  }

  componentDidMount() {
    const currentUser = AuthService.getCurrentUser();
    if (currentUser && currentUser.access_token) {
      AuthService.validateToken(currentUser.access_token).then(
          () => {
            this.props.router.navigate("/");
            //window.location.reload();
          },
          error => {
            document.body.style.backgroundImage = "url('/background.jpeg')";
            document.body.style.backgroundRepeat = "no-repeat";
            document.body.style.backgroundSize = "cover";
            document.body.style.backgroundPosition = "center";
            this.setState({
              loaded: true,
            });
          }
      )
    } else {
      document.body.style.backgroundImage = "url('/background.jpeg')";
      document.body.style.backgroundRepeat = "no-repeat";
      document.body.style.backgroundSize = "cover";
      document.body.style.backgroundPosition = "center";
      this.setState({
        loaded: true,
      });
    }
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  handleLogin(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.login(this.state.username, this.state.password).then(
        () => {
          this.props.router.navigate("/");
          window.location.reload();
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage
          });
        }
      );
    } else {
      this.setState({
        loading: false
      });
    }
  }

  render() {
    return (
        this.state.loaded ?
    <div className="col-md-12 w-100">
      <div className="card card-container">
        <div className="justify-content-center text-center">
          <h4>Welcome Back!</h4>
          <h4>Let's plan a great escape!</h4>
        </div>

        <div className="row" style={{paddingTop: "3rem"}}>
          <div className="col-md-3">
            <h6 style={{color: "#022e4a"}}>Log In</h6>
          </div>
          <div className="col-md-9 text-right">
            <p>Don't have an account? <Link to="/register">
              <span style={{color: "#022e4a"}}><b>Sign Up</b></span>
            </Link></p>

          </div>
        </div>

        <Form
            onSubmit={this.handleLogin}
            ref={c => {
              this.form = c;
            }}
        >
          <div className="form-group">
            <label htmlFor="username">Email Address</label>
            <Input
                type="text"
                className="form-control"
                name="username"
                value={this.state.username}
                onChange={this.onChangeUsername}
                validations={[required]}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <Input
                type="password"
                className="form-control"
                name="password"
                value={this.state.password}
                onChange={this.onChangePassword}
                validations={[required]}
            />
          </div>

          <div className="form-group">
            <button
                className="btn btn-primary btn-block"
                disabled={this.state.loading}
            >
              {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>LOGIN</span>
            </button>
          </div>

          {this.state.message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {this.state.message}
                </div>
              </div>
          )}
          <CheckButton
              style={{display: "none"}}
              ref={c => {
                this.checkBtn = c;
              }}
          />
        </Form>
        <div className="col-md-12 text-right">
          <p><Link to="/forgot-password">
            <span style={{color: "#022e4a"}}>Forgot Password</span>
          </Link></p>

        </div>
      </div>
    </div> : <></>
    );
  }
}

export default withRouter(Login);
